import { render } from "./authority.vue?vue&type=template&id=326d11f8&ts=true"
import script from "./authority.vue?vue&type=script&lang=ts"
export * from "./authority.vue?vue&type=script&lang=ts"

import exportComponent from "/web/CMES_Login_PC/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__